export class SIQSelectionComponentTheme {
  textColor = "null";
  accessoryColor = "null";
  backgroundColor = "null";
  selectionBackgroundColor = "null";
  buttonTextColor = "null";
  buttonBackgroundColor = "null";
  linkTextColor = "null";
}
//# sourceMappingURL=SIQSelectionComponentTheme.js.map